/**
 * Helper функции для работы с GraphQL customAttributes
 */

/**
 * Преобразует массив attributes в объект
 * @example
 * attributesToObject([{key: 'name', value: 'John'}]) => {name: 'John'}
 * attributesToObject([{name: 'role_uuid', value: ['123']}]) => {role_uuid: '123'}
 */
export function attributesToObject(attributes: Array<{key?: string; name?: string; value: any}>): Record<string, any> {
  const result: Record<string, any> = {}
  attributes?.forEach(attr => {
    const key = attr.key || attr.name
    if (!key) return

    // Если value - массив из одного элемента, извлекаем значение
    let value = attr.value
    if (Array.isArray(value) && value.length === 1) {
      value = value[0]
    }

    result[key] = value
  })
  return result
}

/**
 * Преобразует объект в массив attributes для GraphQL
 * @example
 * objectToAttributes({role_uuid: '123', states: ['read', 'create']}) =>
 * [{name: 'role_uuid', value: ['123']}, {name: 'states', value: ['read', 'create']}]
 */
export function objectToAttributes(obj: Record<string, any>): Array<{name: string; value: any[]}> {
  return Object.entries(obj)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => ({
      name: key,
      value: Array.isArray(value) ? value : [value]
    }))
}

/**
 * Извлекает данные из bindings по имени
 * @example
 * getBindingData(bindings, 'permissionUuid') => {uuid, name, ...}
 */
export function getBindingData(bindings: any[], bindingName: string): any {
  const binding = bindings?.find(b => b.name === bindingName)
  return binding?.value
}

/**
 * Извлекает массив данных из bindings по имени
 * @example
 * getBindingDataArray(bindings, 'roles') => [{uuid, name, ...}, ...]
 */
export function getBindingDataArray(bindings: any[], bindingName: string): any[] {
  const binding = bindings?.find(b => b.name === bindingName)
  return binding?.value || []
}
